<template>
<hb-modal 
    @close="$emit('close')"
    title="Save Document"
    v-model="showModal">
    <template v-slot:content>
        <hb-form label="Template Name"
        description="How this template will be listed in template list" full required>
        <HbTextField 
         
            v-model="template.name" 
            v-validate="'required|max:100'" 
            data-vv-name="name"
            data-vv-scope="general" 
            data-vv-as="Template Name"
            :error="errors.has('general.name')" 
            placeholder="Template Name" 
            class="mb-2" 
        />
    </hb-form>    

    <hb-form 
        label="Template Category" 
        description="Select the category of the template" 
        full
        required
        >
            <HbSelect 
                v-model="template.type" 
                :items="template_types" 
                v-validate="'required'" 
                data-vv-scope="general" 
                data-vv-name="category" 
                item-text="name"
                item-value="value"
                data-vv-as="Template Category"
                :error="errors.has('general.category')"
                placeholder="Select Category"
                class="mb-3" 
                @change="clearSelected"
                />
                
    </hb-form>
    
    <hb-form 
        label="Enable Hummingbird Properties" full v-if="show_hb_properties">
            <hb-combobox
                v-if="filterPropertyList.length"
                style="max-width: 720px !important;" 
                v-model="template.Properties" 
                editable 
                :items="filterPropertyList" 
                data-vv-name="property" 
                data-vv-as="properties" 
                item-text="name"
                data-vv-scope="general" 
                label="Select properties"
            />
        </hb-form> 
    <hb-form 
        label="Enable Non-Hummingbird Properties" full v-if="show_nonhb_properties">
            <hb-combobox
                style="max-width: 720px !important;" 
                v-model="template.nonHbProps" 
                editable 
                :items="nonHbProps" 
                data-vv-name="nonhb" 
                data-vv-as="properties" 
                item-text="name"
                data-vv-scope="general" 
                label="Select properties"
            />
        </hb-form> 
    
        <hb-form label="Upload Template" full >
            <HbFileInput v-if="!template.id" v-model="files"  />
        </hb-form> 
    </template>
    <template v-slot:actions>
        
        <hb-btn :disabled="is_form_saving" color="primary" class="ml-2" @click="saveTemplate">Save</hb-btn>
        <span v-show="is_form_saving">
             <v-progress-circular
                        indeterminate
                        size="24" 
                        width="2"
                        color="primary"
                    ></v-progress-circular>
        </span>
    </template>
</hb-modal>
</template>


<script type="text/babel">

        
    import api from '../../../assets/api.js';
    import { mapGetters } from "vuex";
    import Loader from '../../assets/CircleSpinner.vue';
    export default {
        name: "DocumentTemplateDetails",
        data() {
            return {
                nonHbProps: [],
                is_form_saving: false,
                showModal: true,
                files: [], 
                template: {
                    id: "", 
                    carboneTemplateId: null, 
                    name: '',
                    type: '',
                    Properties: [],
                    nonHbProps: [],
                    template: '',
                },
                template_types: [],
                show_hb_properties: false,
                show_nonhb_properties: false,
                
            }
        },
        components:{
            Loader
        }, 
        props: ['selected', 'is_saving'],
        async created(){
            await this.getDocumentTypes();
            await this.fetchNonHbProperties();
            if(this.$props.selected?.id){
                let template = JSON.parse(JSON.stringify(this.$props.selected))
                let Properties = []
                let nonProperties = []
                template.Properties.forEach(element => {
                    if (this.nonHbProperties.includes(element.gds_id) || this.nonHbProperties.includes(element.id)) {
                        nonProperties.push(element)
                    } else {
                        Properties.push(element)
                    }
                });
                this.template.name = template.name; 
                this.template.type = template.type; 
                this.setType(this.template.type)
                this.template.Properties = Properties
                this.template.nonHbProps = nonProperties
                this.template.id = template.id; 
            }
            else {
                this.template.Properties = []
                this.template.nonHbProps = []
                this.setType(this.template.type)
            }
        },
        computed:{
            ...mapGetters({
                facilityList: 'propertiesStore/filtered',
                nonHbProperties: 'propertiesStore/nonHbProperties'
            }),
            filterPropertyList() {
                return this.facilityList.map(obj => ({ id: obj.id, name: obj.name }));
            }
        },
        methods:{
            async fetchNonHbProperties(){
                api.get(this, api.NON_HB_PROPERTIES).then(r => {
                    this.nonHbProps = r.properties.map(p => {
                        return {
                            id: p?.id,
                            name: p?.name,
                            number: p?.number,
                            city: this.$options?.filters?.formatAddress(p?.Address),
                            gds_id: p?.gds_id ?? ""
                        }
                    });
                });
            },

            async getDocumentTypes(){
                try {
                    let response = await this.$http.get(api.DOCUMENT + '/types');
                    this.template_types = response.body.data.types;
                } catch(err){
                    console.log(err)
                }
            }, 


            readFile(file){
                console.log('file :>> ', file)
                try {
                    return new Promise((resolve, reject) => {
                        var fr = new FileReader();  
                        fr.onload = () => {
                            resolve(fr.result)
                        };
                        fr.onerror = reject;
                        fr.readAsDataURL(file);
                    });
                } catch (error) {
                    this.showMessageNotification({ description: error })
                }
            },
            setType(newType) {
                const thistype = this.template_types.find(typ => typ.value == newType)
                if (thistype) {
                    this.show_hb_properties = !!thistype.show_hb_properties
                    this.show_nonhb_properties = !!thistype.show_nonhb_properties
                }
                else {
                    this.show_hb_properties = true
                    this.show_nonhb_properties = false
                }              
            },
            async saveTemplate(){   
                const status = await this.$validator.validateAll('general');
                if (!status) return 
                // // set this.properties to all 
                if(this.files.length){
                    let file = this.files[0]
                    console.log("file", file)
                    let fileType = file.type.split("/")[0]
                    let base64 = await this.readFile(file);
                    let splits = base64.split('base64,')
                    this.template.template = `${splits[1]}`
                }

                if(!status) {
                    // this.showMessageNotification({ type: 'error', description: 'There are errors in your form, correct them before continuing.',list: this.errors.items });
                    return;
                };
                this.show_hb_properties = false
                this.show_nonhb_properties = false
                this.template.Properties.push(...this.template.nonHbProps)
                this.$emit('save', this.template)
                this.is_form_saving = true; 
                 
            },
            async clearSelected() {
                this.template.Properties = []
                this.template.nonHbProps = []
            }
        },
        watch: {
            'template.type'(newType) {
                this.setType(newType)
            }
        }
    }
</script>